/**
 * ホーム・通知・申請・インシデント・設定・ログインで足した文言（ja / en）。
 * 見出し・ボタンは「〜する」の能動形。トーストはボタンと同じ動詞。
 */
export const ja: Record<string, string> = {
  "login.err.missing": "メールアドレスとパスワードを入力してください。",

  "home.todo": "あなたのやること",
  "home.greeting": "{hello}、{name}さん。",
  "home.hello.morning": "おはようございます",
  "home.hello.day": "こんにちは",
  "home.hello.evening": "こんばんは",
  "home.count": "やることが {n} 件あります。",
  "home.none": "今日やることはありません。",
  "home.noneBody": "新しい依頼が来たら、ここと通知に出ます。",
  "home.unread": "未読の通知が {n} 件あります",
  "home.verb.approve": "承認する",
  "home.verb.apply": "実施を記録する",
  "home.verb.fix": "差し戻しを確かめる",
  "home.verb.train": "受講する",
  "home.verb.obligation": "対応する",
  "home.star3": "★3 の準備状況",
  "home.star3.open": "準備度を詳しく見る",
  "home.m.evidence": "証跡が揃った評価基準",
  "home.m.vacant": "担当が未定のロール",
  "home.m.overdue": "期限を過ぎた義務",
  "home.m.next": "次の期限",
  "home.next.overdue": "次にやること: 期限を過ぎた {n} 件に対応する",
  "home.next.vacant": "次にやること: 未定の {n} ロールの担当を決める",
  "home.next.gap": "次にやること: {code} の証跡を揃える",
  "home.next.deadline": "次にやること: {title}",

  "onboard.title": "はじめての方へ",
  "onboard.tasks": "ホームの「あなたのやること」から、承認・受講・点検の回答に1タップで入れます。",
  "onboard.reportCall": "インシデントに気付いたら、まず {name}さん（{role}・{tel}）に電話し、そのあと「報告」から送ってください。",
  "onboard.confirmer": "「評価基準」で自己評価を確かめ、問題が無ければ署名します。署名の依頼はホームと通知に届きます。",
  "onboard.deptHead": "部署の点検の回答依頼と、部署の人の申請は、ホームと「申請」の「部署の申請」で確かめられます。",
  "onboard.report": "インシデントに気付いたら、まず電話。そのあと「報告」から3項目で第一報を出せます。",
  "onboard.manager": "「準備度」で ★3 の進み具合と、次にやるべき1件が分かります。",
  "onboard.approver": "「申請」の「自分の対応待ち」で、承認するとどう変わるかを見てから承認できます。",
  "onboard.staff": "教育の受講と各種の申請は、それぞれの画面から行えます。迷ったら「探す」で画面を探せます。",
  "onboard.close": "分かった（閉じる）",
  "onboard.again": "設定からもう一度表示できます。",
  "onboard.reshow": "案内をもう一度表示する",
  "onboard.reshowHint": "ホームの上に、あなたのロールでできることの短い案内を出します。",
  "onboard.reshown": "次にホームを開くと案内が出ます",

  "notif.readAllAction": "すべて既読にする",
  "notif.readAllDone": "すべて既読にしました",
  "notif.unreadLine": "未読が {n} 件あります。開くと既読になります。",
  "notif.intro": "督促・承認の依頼・未受講のお知らせがここに届きます。",
  "notif.emptyBody": "督促や承認の依頼が来ると、ここに出ます。",
  "notif.unreadMark": "未読",

  "inc.deputy": "代理",
  "inc.detectedAtWhen": "いつ気付いたか",
  "inc.detectedAtLocalHint2": "この端末の時刻で入れてください。一覧では日本時間で表示します。",
  "inc.moreDetails": "詳しく書く（任意）",
  "inc.assetsHint": "複数あるときは「、」で区切ります。",
  "inc.laterNote": "分かっていることだけで送ってください。原因や対応は、担当者が段階を進めるときに追記します。",
  "inc.submitAction": "報告を送る",
  "inc.submitting": "送っています…",
  "inc.reportedToast": "報告しました（受付番号 {no}）",
  "inc.receivedTitle": "報告を受け付けました",
  "inc.reportAnother": "別の件を報告する",
  "inc.err.summary": "何が起きたかを書いてください",
  "inc.err.detectedAt": "気付いた日時を入れてください",
  "inc.err.future": "気付いた日時が未来になっています。端末の時刻を確かめて入れ直してください",
  "inc.listTitle": "記録されたインシデント",
  "inc.listRestrictedTitle": "一覧は担当者だけが見られます",
  "inc.status": "状態",
  "inc.notYet": "未報告",
  "inc.markedReported": "報告済みにしました",
  "inc.advanced": "段階を進めました",
  "inc.advanceTo": "「{next}」に進める",
  "inc.decisionSaved": "判断を記録しました。",
  "inc.shareSubmit": "教材にする",
  "common.actions": "操作",

  "req.newAction": "新しく申請する",
  "req.waitingOn": "誰で止まっているか",
  "req.empty.mineTitle": "あなたが出した申請はまだありません。",
  "req.submittedToast": "提出しました（申請番号 {no}）",
  "req.approvedToast": "承認しました",
  "req.returnedToast": "差し戻しました",
  "req.rejectedToast": "却下しました",
  "req.appliedToast": "実施を記録しました",
  "req.withdrawnToast": "取り下げました",
  "req.thisRequest": "この申請",
  "req.backToList": "一覧へ戻る",
  "req.approvalSteps": "承認の流れ",
  "req.commentShort": "コメント",
  "req.commentNeeded": "差し戻す・却下するときは、理由をコメントに書いてください（申請者に表示されます）。",
  "step.stampApproved": "承認",
  "req.decisionBar": "この申請への決定",
  "req.returnOrReject": "差し戻す・却下する",
  "err.requiredField": "{label}を入力してください",
  "err.chooseField": "{label}を選択肢から選んでください",
  "form.rowN": "{n}行目",
  "form.deleteRowN": "{n}行目を削除する",

  "set.language": "表示言語",
  "set.totpOpenApp": "認証アプリで開く",
  "set.totpOpenAppHint": "このスマホに認証アプリが入っていれば、押すとアプリが開いて登録されます。開かないときは下の「QRコードを読み取れない場合」のキーを使ってください。",
  "set.totpCopyKey": "キーをコピーする",
  "set.totpKeyCopied": "キーをコピーしました。認証アプリに貼り付けたら、クリップボードから消してください",
  "set.totpKeyCopyFailed": "コピーできませんでした。キーを長押しして選んでください",
  "inc.photo": "写真（任意）",
  "inc.photoHint": "カメラで撮るか、撮った写真・PDF を選びます（1つ {mb}MB まで）。写真は送る前にこの端末で小さくします。報告を受け付けた後に送ります。",
  "inc.photosTitle": "写真・PDF",
  "inc.photoChosen": "選んだ写真",
  "inc.photoAdd": "写真・PDF を追加する",
  "inc.photoNone": "まだ付いていません。",
  "inc.photo.waiting": "待機中",
  "inc.photo.sending": "送信中",
  "inc.photo.done": "送信済み",
  "inc.photo.failed": "送れませんでした",
  "inc.photoFailedSaved": "報告（受付番号 {no}）は受け付け済みです。送れなかった写真だけ「もう一度送る」を押してください。",
  "inc.photoNoApi": "報告（受付番号 {no}）は受け付け済みです。ただ、このサーバーはまだ写真を受け取れません。写真はこの受付番号を添えてインシデント一次受付の担当者に渡してください。",
  "inc.photoNoApiShort": "このサーバーはまだ写真を受け取れません。",
  "inc.photoKind": "画像（JPEG・PNG・WebP・HEIC）か PDF",
  "inc.photoRemove": "{name} を外す",
  "set.pwChangedToast": "パスワードを変更しました",
  "set.totpSixDigits": "6桁の数字を入れてください",
  "set.totpDisableConfirm": "多要素認証を解除します。次のログインからパスワードだけで入れるようになります（ローカル認証の人は再登録が必要になります）。解除しますか？",
};

export const en: Record<string, string> = {
  "login.err.missing": "Enter your email address and password.",

  "home.todo": "Your tasks",
  "home.greeting": "{hello}, {name}.",
  "home.hello.morning": "Good morning",
  "home.hello.day": "Hello",
  "home.hello.evening": "Good evening",
  "home.count": "You have {n} tasks.",
  "home.none": "Nothing to do today.",
  "home.noneBody": "New requests will appear here and in Notifications.",
  "home.unread": "{n} unread notifications",
  "home.verb.approve": "Approve",
  "home.verb.apply": "Record implementation",
  "home.verb.fix": "Check returned request",
  "home.verb.train": "Take training",
  "home.verb.obligation": "Handle",
  "home.star3": "★3 readiness",
  "home.star3.open": "See readiness in detail",
  "home.m.evidence": "Criteria with complete evidence",
  "home.m.vacant": "Roles without a holder",
  "home.m.overdue": "Overdue obligations",
  "home.m.next": "Next deadline",
  "home.next.overdue": "Next: handle {n} overdue item(s)",
  "home.next.vacant": "Next: assign holders to {n} role(s)",
  "home.next.gap": "Next: complete the evidence for {code}",
  "home.next.deadline": "Next: {title}",

  "onboard.title": "Getting started",
  "onboard.tasks": "“Your tasks” on Home takes you to approvals, training and inspection answers in one tap.",
  "onboard.reportCall": "If you notice an incident, call {name} ({role}, {tel}) first, then send a report from “Report”.",
  "onboard.confirmer": "Review the self-assessment under “Criteria” and sign it when you are satisfied. Signing requests arrive on Home and in Notifications.",
  "onboard.deptHead": "Inspection requests for your department and your members’ requests are on Home and under Requests › My department’s requests.",
  "onboard.report": "If you notice an incident, phone first, then use “Report” to send a first report in three fields.",
  "onboard.manager": "“Readiness” shows ★3 progress and the single next thing to do.",
  "onboard.approver": "In Requests → “Awaiting my action” you can see what approval will change before approving.",
  "onboard.staff": "Training and requests each have their own screen. Use “Search” if you get lost.",
  "onboard.close": "Got it (close)",
  "onboard.again": "You can show this again from Settings.",
  "onboard.reshow": "Show the guide again",
  "onboard.reshowHint": "Shows a short guide on Home about what your roles can do.",
  "onboard.reshown": "The guide will appear next time you open Home",

  "notif.readAllAction": "Mark all as read",
  "notif.readAllDone": "Marked all as read",
  "notif.unreadLine": "{n} unread. Opening one marks it as read.",
  "notif.intro": "Reminders, approval requests and training notices arrive here.",
  "notif.emptyBody": "Reminders and approval requests will appear here.",
  "notif.unreadMark": "unread",

  "inc.deputy": "Deputy",
  "inc.detectedAtWhen": "When did you notice it",
  "inc.detectedAtLocalHint2": "Use this device's time. Lists show Japan time.",
  "inc.moreDetails": "Add more details (optional)",
  "inc.assetsHint": "Separate multiple items with commas.",
  "inc.laterNote": "Send what you know now. Cause and response are added later by the incident team.",
  "inc.submitAction": "Send report",
  "inc.submitting": "Sending…",
  "inc.reportedToast": "Reported (reference no. {no})",
  "inc.receivedTitle": "Your report was received",
  "inc.reportAnother": "Report another",
  "inc.err.summary": "Describe what happened",
  "inc.err.detectedAt": "Enter when you noticed it",
  "inc.err.future": "The time is in the future. Check your device clock and enter it again",
  "inc.listTitle": "Recorded incidents",
  "inc.listRestrictedTitle": "Only the incident team can see the list",
  "inc.status": "Status",
  "inc.notYet": "Not reported",
  "inc.markedReported": "Marked as reported",
  "inc.advanced": "Stage advanced",
  "inc.advanceTo": "Advance to “{next}”",
  "inc.decisionSaved": "Decision recorded.",
  "inc.shareSubmit": "Create course",
  "common.actions": "Actions",

  "req.newAction": "New request",
  "req.waitingOn": "Waiting on",
  "req.empty.mineTitle": "You have not submitted any requests yet.",
  "req.submittedToast": "Submitted (request no. {no})",
  "req.approvedToast": "Approved",
  "req.returnedToast": "Sent back",
  "req.rejectedToast": "Rejected",
  "req.appliedToast": "Implementation recorded",
  "req.withdrawnToast": "Withdrawn",
  "req.thisRequest": "This request",
  "req.backToList": "Back to list",
  "req.approvalSteps": "Approval steps",
  "req.commentShort": "Comment",
  "req.commentNeeded": "To send back or reject, write the reason in the comment (the applicant will see it).",
  "step.stampApproved": "Approved",
  "req.decisionBar": "Decision on this request",
  "req.returnOrReject": "Send back / reject",
  "err.requiredField": "Please fill in {label}",
  "err.chooseField": "Please choose {label}",
  "form.rowN": "Row {n}",
  "form.deleteRowN": "Remove row {n}",

  "set.language": "Display language",
  "set.totpOpenApp": "Open in authenticator app",
  "set.totpOpenAppHint": "If an authenticator app is installed on this phone, tapping this opens it and adds the account. If nothing opens, use the key under “Can't scan the QR code”.",
  "set.totpCopyKey": "Copy key",
  "set.totpKeyCopied": "Key copied. After pasting it into your authenticator app, clear it from the clipboard",
  "set.totpKeyCopyFailed": "Could not copy. Press and hold the key to select it",
  "inc.photo": "Photos (optional)",
  "inc.photoHint": "Take a photo or choose a photo/PDF (up to {mb} MB each). Photos are resized on this device and sent after the report is received.",
  "inc.photosTitle": "Photos and PDFs",
  "inc.photoChosen": "Chosen photos",
  "inc.photoAdd": "Add photos or PDFs",
  "inc.photoNone": "None attached yet.",
  "inc.photo.waiting": "Waiting",
  "inc.photo.sending": "Sending",
  "inc.photo.done": "Sent",
  "inc.photo.failed": "Not sent",
  "inc.photoFailedSaved": "Your report (reference no. {no}) has been received. Press “Send again” only for the photos that failed.",
  "inc.photoNoApi": "Your report (reference no. {no}) has been received, but this server cannot accept photos yet. Give the photos to the incident intake contact together with this reference number.",
  "inc.photoNoApiShort": "This server cannot accept photos yet.",
  "inc.photoKind": "image (JPEG, PNG, WebP, HEIC) or PDF",
  "inc.photoRemove": "Remove {name}",
  "set.pwChangedToast": "Password changed",
  "set.totpSixDigits": "Enter the 6 digits",
  "set.totpDisableConfirm": "Disable multi-factor authentication? Local-account users will have to register again before using the system. Disable it?",
};
